import type { ReactNode } from 'react'

import { Card, CardAction, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'

interface FillSectionCardProps {
  title?: string
  action?: ReactNode
  className?: string
  /** No card around it, for a surface that's already one, e.g. a dialog: sections split by a rule instead. */
  plain?: boolean
  children: ReactNode
}

/** One part of a tab, e.g. Business owner or Trucks. */
export function FillSectionCard({ title, action, className, plain, children }: FillSectionCardProps) {
  if (plain) {
    return (
      <section className={cn('flex flex-col gap-4 border-t pt-6 first:border-t-0 first:pt-0', className)}>
        {title && (
          <div className="flex items-center justify-between gap-3">
            <h3 className="text-ink text-md leading-none font-semibold">{title}</h3>
            {action}
          </div>
        )}
        {children}
      </section>
    )
  }

  return (
    <Card className={cn('gap-4 shadow-none', className)}>
      {title && (
        // gap-0: without a description the header would keep the gap above its empty second row.
        <CardHeader className="gap-0">
          <CardTitle className="text-ink text-md">{title}</CardTitle>
          {action && <CardAction>{action}</CardAction>}
        </CardHeader>
      )}
      <CardContent className="flex flex-col gap-4">{children}</CardContent>
    </Card>
  )
}
